module.exports = __webpack_public_path__ + "img/bg_slide_3.7a51eba8.jpg";